import React, { useCallback } from "react";
import { Editor } from "slate";
import { DefaultElement, ReactEditor } from "slate-react";

import { ElementProps, SlatePlugin } from "components/slate/types";
import { DragOverlayWrapper } from "components/slate/wrapper/DragOverlayContent";

const useDragOverlayRenderElement = (
  editor: Editor,
  plugins: SlatePlugin[]
) => {
  const renderers = plugins
    .filter((x) => x.renderElement)
    .map((x) => x.renderElement!);

  const renderElement = useCallback(
    (props) => {
      const { attributes, element } = props;

      const path = ReactEditor.findPath(editor, element);

      if (path.length === 1) {
        return (
          <DragOverlayWrapper attributes={attributes} element={element}>
            {renderElementContent(props, renderers)}
          </DragOverlayWrapper>
        );
      }

      return renderElementContent(props, renderers);
    },
    [editor]
  );

  return renderElement;
};

export default useDragOverlayRenderElement;

export const renderElementContent = (
  props: ElementProps,
  renderers: ((props: ElementProps) => JSX.Element | null)[]
) => {
  for (const render of renderers) {
    const rendered = render(props);

    if (rendered) {
      return rendered;
    }
  }

  return (
    <DefaultElement
      children={props.children}
      element={props.element}
      attributes={props.attributes!}
    />
  );
};
